export default()=>{
    return{
        type: "logout"
    }
}